import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import styled from '@emotion/styled';
import { useField } from 'formik';
import 'react-datepicker/dist/react-datepicker.css';

const DatePicker = props => {
  const { label, name, setFieldValue } = props;
  const [startDate, setStartDate] = useState(new Date());
  return (
    <div className='form-group '>
      <label className='col-form-label' htmlFor={name}>
        {label} :
      </label>
      <Container className=''>
        <ReactDatePicker
          name={name}
          id={name}
          selected={startDate}
          onChange={date => {
            setStartDate(date);
            setFieldValue(name, date);
          }}
        />
      </Container>
    </div>
  );
};

export default DatePicker;

const Container = styled.div`
  .react-datepicker {
    background-color: #1e1e2d;
  }
  .react-datepicker-wrapper {
    display: block;
  }
  .react-datepicker-popper {
    z-index: 9999999;
  }
  .react-datepicker__input-container input {
    display: block;

    width: 100%;

    height: calc(1.5em + 1.3rem + 2px);

    padding: 0.65rem 1rem;

    font-size: 1rem;

    font-weight: 400;

    line-height: 1.5;

    color: #495057;

    background-color: #fff;

    background-clip: padding-box;

    border: 1px solid #e2e5ec;

    border-radius: 4px;

    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  .react-datepicker__header {
    background-color: #1a1a27;
    border-bottom: none;
  }
  .react-datepicker__current-month,
  .react-datepicker-time__header,
  .react-datepicker-year-header,
  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    color: #fff;
  }
  .react-datepicker__day:hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover {
    background-color: #000;
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range,
  .react-datepicker__month-text--selected,
  .react-datepicker__month-text--in-selecting-range,
  .react-datepicker__month-text--in-range,
  .react-datepicker__quarter-text--selected,
  .react-datepicker__quarter-text--in-selecting-range,
  .react-datepicker__quarter-text--in-range {
    background-color: #216ba5;
  }

  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow {
    margin-bottom: -7px;
  }
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle {
    margin-top: -7px;
  }

  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='bottom']
    .react-datepicker__triangle::before {
    border-bottom-color: #1e1e2d;
  }
  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,
  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow,
  .react-datepicker-popper[data-placement^='top']
    .react-datepicker__triangle::before,
  .react-datepicker__year-read-view--down-arrow::before,
  .react-datepicker__month-read-view--down-arrow::before,
  .react-datepicker__month-year-read-view--down-arrow::before {
    border-top-color: #1e1e2d;
  }
`;
